const FREE_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'hotmail.com',
  'outlook.com',
  'live.com',
  'msn.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
]);

export const getEmailDomain = (
  email: string | undefined | null,
): string | undefined =>
  email?.includes('@')
    ? email.split('@').at(-1)?.trim().toLowerCase() || undefined
    : undefined;

export const isFreeEmailDomain = (domain: string): boolean =>
  FREE_EMAIL_DOMAINS.has(domain.trim().toLowerCase());
